// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetNaturaTypesQueryVariables = Types.Exact<{
  request: Types.InputMaybe<Types.GetNaturaTypesRequestDtoInput>;
}>;


export type GetNaturaTypesQueryResult = { __typename?: 'Query', getNaturaTypes: Array<Types.NaturaTypeEnumDto> };

export const GetNaturaTypesGql = gql`
    query GetNaturaTypes($request: GetNaturaTypesRequestDTOInput) {
  getNaturaTypes(request: $request)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNaturaTypesInjectable extends Apollo.Query<GetNaturaTypesQueryResult, GetNaturaTypesQueryVariables> {
    override document = GetNaturaTypesGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */